import React from 'react';

import {UserSuggestList} from 'src/components/user-suggest-list/user-suggest-list';

import {Autosuggest} from '@pb/kit-component-autosuggest-v2';
import {Group, Item} from '@pb/kit-component-group';
import {Icon, Icons} from '@pb/kit-component-icon';
import {Input} from '@pb/kit-component-input-v2';
import Label from '@pb/kit-component-label';


import type {UserShortInfo} from 'src/openapi/admin/models/UserShortInfo';

type Props = {
    emailInput: string,
    shown: boolean,
    firstName: string,
    lastName: string,
    suggestUsers: UserShortInfo[],
    searchLoading: boolean,
    hasSearched: boolean,
    isMinQueryShown: boolean,
    onEmailChange: (e: React.ChangeEvent<HTMLInputElement>) => void,
    onUserSelect: (user: UserShortInfo) => void,
    onClearSuggest: () => void,
    onSetShown: (shown: boolean) => void,
    onBlur?: () => void,
};

const MAX_LEN = 100;

export const AddVendorUserForm: React.FC<Props> = ({
    emailInput,
    shown,
    firstName,
    lastName,
    suggestUsers,
    searchLoading,
    hasSearched,
    isMinQueryShown,
    onEmailChange,
    onUserSelect,
    onClearSuggest,
    onSetShown,
    onBlur,
}) => {
    const shouldShowSuggest = shown
        && emailInput.trim().length > 0
        && (searchLoading || suggestUsers.length > 0 || isMinQueryShown);

    return (
        <Group gap="m" direction="v">
            <Item>
                <Label htmlFor="addVendorUserEmailInputId">Email</Label>
                <Autosuggest
                    id="addVendorUserEmailInputId"
                    value={emailInput}
                    shown={shouldShowSuggest}
                    setShown={onSetShown}
                    onChange={onEmailChange}
                    placeholder="Enter user email"
                    maxLength={MAX_LEN}
                    onItemSelect={onUserSelect}
                    onClear={onClearSuggest}
                    onBlur={onBlur}>
                    <UserSuggestList
                        id="vendor-user-suggest-list"
                        busy={searchLoading}
                        users={suggestUsers}
                        hasSearched={hasSearched}
                        isMinQueryShown={isMinQueryShown}
                    />
                </Autosuggest>
            </Item>
            <Item>
                <Label htmlFor="addVendorUserFirstNameInputId">First Name</Label>
                <Input
                    id="addVendorUserFirstNameInputId"
                    readOnly={true}
                    value={firstName}
                    placeholder="First name"
                    endAdornment={<Icon type={Icons.LOCK} size="Size_14"/>}
                />
            </Item>
            <Item>
                <Label htmlFor="addVendorUserLastNameInputId">Last Name</Label>
                <Input
                    id="addVendorUserLastNameInputId"
                    readOnly={true}
                    value={lastName}
                    placeholder="Last name"
                    endAdornment={<Icon type={Icons.LOCK} size="Size_14"/>}
                />
            </Item>
        </Group>
    );
};
